import mixpanel from "mixpanel-browser";

import { isMixpanelInitialized } from "./mixpanel.service";

const EventName = {
  AE_ACTION_FORM_DELETE_ALL_PARCELS: "ae_action_form_delete_all_parcels",
  AE_DIALS: "ae_dials",
  AE_FILTER_APPLIED: "ae_filter_applied",
  AE_MAP_LAYERS: "ae_map_layers",
  AE_MAP_LAYERS_TOGGLE: "ae_map_layers_toggle",
  AE_MAP_PARCELS: "ae_map_parcels",
  AE_MAP_PARCELS_ALWAYS_SHOW: "ae_map_parcels_always_show",
  AE_MAP_PARCELS_CLOSE: "ae_map_parcels_close",
  AE_MAP_PARCELS_SETTINGS: "ae_map_parcels_settings",
  AE_MAP_PARCELS_SETTINGS_BACK: "ae_map_parcels_settings_back",
  AE_MAP_PARCELS_SETTINGS_TOGGLE: "ae_map_parcels_settings_toggle",
  AE_MAP_PARCELS_VISIBILITY: "ae_map_parcels_visibility",
  AE_MAP_PARCELS_LOCATE: "ae_map_parcels_locate",
  AE_MAP_PARCELS_SEARCH_FILTERS: "ae_map_parcels_search_filters",
  AE_MAP_PARCELS_SEASONS: "ae_map_parcels_seasons",
  AE_MAP_PARCELS_SEARCH: "ae_map_parcels_search",
  AE_MAP_PARCELS_SHOW_ALL: "ae_map_parcels_show_all",
  AE_MAP_PARCELS_HIDE_ALL: "ae_map_parcels_hide_all",
  AE_MAP_PARCELS_LIST_ITEM: "ae_map_parcels_list_item",
  AE_MAP_PARCELS_MAP_CLICK: "ae_map_parcels_map_click",
  AE_MAP_PARCELS_DETAIL_BACK: "ae_map_parcels_detail_back",
  AE_FILTER_NON_FIELD_ACTION: "ae_filter_non_field_action",
  AE_FILTER_NON_FIELD_ACTION_OBJECT: "ae_filter_non_field_action_object",
  AE_NON_FIELD_ACTION_ADD: "ae_non_field_action_add",
  AE_NON_FIELD_ACTION_DUPLICATE: "ae_non_field_action_duplicate",
  AE_NON_FIELD_ACTION_OBJECT_DIALS: "ae_non_field_action_object_dials",
  AE_NON_FIELD_ACTION_RESET: "ae_non_field_action_reset",
  AE_NON_FIELD_ACTION_SHOW_NON_ACTIVE_VERSIONS:
    "ae_non_field_action_show_non_active_versions",
  AE_NON_FIELD_ACTION_SHOW_NON_REGISTERED_PRODUCTS:
    "ae_non_field_action_show_non_registered_products",
  AE_PLUS_BTN_NON_FIELD_ACTION: "ae_plus_btn_non_field_action",
  HELP_ICON: "help_icon",
  AE_POR: "ae_por",
  AE_POR_ADD: "ae_por_add",
  AE_POR_ADDED: "ae_por_added",
  AE_POR_CROP: "ae_por_crop",
  AE_POR_CROP_DETAIL: "ae_por_crop_detail",
  AE_POR_DETAIL: "ae_por_detail",
  AE_POR_LIST_ITEM: "ae_por_list_item",
  AE_POR_REGISTRATION: "ae_por_registration",
  SUPPORT: "support",
  TUTORIALS: "tutorials",
  PF_SECTION: "pf_section",
  PF_ACTIVE_SERVICES: "pf_active_services",
  PF_PARCEL_NITROGEN_TAB: "pf_parcel_nitrogen_tab",
  PF_ADD_NITROGEN_APPLICATION: "pf_add_nitrogen_application",
  PF_SAVE_NITROGEN_APPLICATION: "pf_save_nitrogen_application",
  PF_CREATE_ZONING_MAP: "pf_create_zoning_map",
  PF_CREATE_ZONING_MAP_FILTER: "pf_create_zoning_map_filter",
  PF_CREATE_ZONING_MAP_ADD_PARCEL: "pf_create_zoning_map_add_parcel",
  PF_FERTILIZATION_SELECT: "pf_fertilization_select",
  PF_AUTO_DOSING_TURN_OFF: "pf_auto_dosing_turn_off",
  PF_MATERIAL_AND_DOSING_APPLY: "pf_material_and_dosing_apply",
  PF_MATERIAL_AND_DOSING: "pf_material_and_dosing",
  PF_PARCEL_DETAIL_AUTO_DOSING: "pf_parcel_detail_auto_dosing",
  PF_PARCEL_DETAIL_APPLY: "pf_parcel_detail_apply",
  PF_CREATE_ZONING_MAP_SAVE: "pf_create_zoning_map_save",
  PF_ZONING_MAPS: "pf_zoning_maps",
  PF_ZONING_MAPS_SEND_DATA: "pf_zoning_maps_send_data",
  PF_ZONING_MAPS_SEND_DATA_CREATE_FILE: "pf_zoning_maps_send_data_create_file",
  PF_ZONING_MAPS_SEND_DATA_JD: "pf_zoning_maps_send_data_jd",
  PF_ZONING_MAPS_SEND_DATA_CNHI: "pf_zoning_maps_send_data_cnhi",
  PF_ZONING_MAPS_SEND_DATA_CREATE_FILE_DOWNLOAD:
    "pf_zoning_maps_send_data_create_file_download",
  PF_ZONING_MAPS_SEND_DATA_CREATE_FILE_SEND:
    "pf_zoning_maps_send_data_create_file_send",
  PF_ZONING_MAPS_SEND_DATA_CREATE_FILE_VEHICLES:
    "pf_zoning_maps_send_data_create_file_vehicles",
  INTEGRATIONS_SECTION: "integrations_section",
  INTEGRATIONS_CONNECT: "integrations_connect",
  INTEGRATIONS_SETTINGS: "integrations_settings",
  INTEGRATIONS_SETTINGS_OPEN: "integrations_settings_open",
  INTEGRATIONS_DISCONNECT: "integrations_disconnect",
  INTEGRATIONS_ORGANIZATION_SAVE: "integrations_organization_save",
  AE_SOWING_CREATE: "ae_sowing_create",
  AE_SOWING_EDIT: "ae_sowing_edit",
  AE_SOWING_EDIT_FAILURE: "ae_sowing_edit_failure",
  AE_SOWING_DELETE: "ae_sowing_delete",
  HELP_VERSION_HISTORY: "help_version_history",
  SENSORS_HYDRO_LIMITS_SAVE: "sensors_hydro_limits_save",
  SENSORS_HYDRO_LIMITS_CHART_TOGGLE: "sensors_hydro_limits_chart_toggle",
  TEL_DASHBOARD: "tel_dashboard",
  TEL_DASHBOARD_METRIC: "tel_dashboard_metric",
  TEL_DASHBOARD_BREAKDOWN: "tel_dashboard_breakdown",
  TEL_DASHBOARD_DRIVER_DETAIL: "tel_dashboard_driver_detail",
  TEL_DASHBOARD_DRIVER_LINK: "tel_dashboard_driver_link",
  TEL_DASHBOARD_EXPORT: "tel_dashboard_export",
  ERROR_GAME_START: "error_game_start",
  ERROR_GAME_OVER: "error_game_over",
} as const;

type ErrorGameStartEventProps = {
  errorCode: number;
};

type ErrorGameOverEventProps = {
  errorCode: number;
  score: number;
};

type ActivityFilterScreen = "overview" | "parcel";

type FilterAppliedEventProps = {
  filter: string;
  screen: ActivityFilterScreen;
};

type SowingEventProps = {
  count: number;
  skipped: number;
  // Which attributes the bulk operation touched (dateStart, dateEnd, seed,
  // cropUseType, mainProduct, catchCrop) — lets us see what changes most.
  attributes?: string[];
  // Number of distinct sowing groups included in the edit selection.
  groupCount?: number;
};

type SowingEditFailureEventProps = {
  attributes: string[];
  groupCount: number;
};

type HydroLimitsSaveEventProps = {
  // Which of the three limits the user actually filled in — each one is
  // optional, so this shows whether the whole triplet gets used in practice.
  limits: string[];
};

type MapLayersToggleEventProps = {
  layer: string;
  on: boolean;
};

type MapParcelsSource = "list" | "detail";

type MapParcelsAlwaysShowEventProps = {
  on: boolean;
};

type MapParcelsSettingsToggleEventProps = {
  setting: "name" | "blockNumber" | "area";
  on: boolean;
};

type MapParcelsVisibilityEventProps = {
  source: MapParcelsSource;
  on: boolean;
};

type MapParcelsLocateEventProps = {
  source: MapParcelsSource;
};

type HydroLimitsChartToggleSource = "sensor-chart" | "sensors-dashboard";

type HydroLimitsChartToggleEventProps = {
  visible: boolean;
  source: HydroLimitsChartToggleSource;
};

type TelDashboardMetricEventProps = {
  metric: string;
};

type TelDashboardBreakdownEventProps = {
  dimension: string;
};

type TelDashboardDriverLinkEventProps = {
  target: "drivers" | "unapproved" | "logbook";
};

const track = (
  event: (typeof EventName)[keyof typeof EventName],
  properties?: Record<string, unknown>,
): void => {
  if (!isMixpanelInitialized()) return;
  mixpanel.track(event, properties);
};

const trackAeActionFormDeleteAllParcels = (): void =>
  track(EventName.AE_ACTION_FORM_DELETE_ALL_PARCELS);

const trackAeFilterApplied = (p: FilterAppliedEventProps): void =>
  track(EventName.AE_FILTER_APPLIED, p);

const trackAeFilterNonFieldAction = (): void =>
  track(EventName.AE_FILTER_NON_FIELD_ACTION);

const trackAeFilterNonFieldActionObject = (): void =>
  track(EventName.AE_FILTER_NON_FIELD_ACTION_OBJECT);

const trackAeNonFieldActionAdd = (): void =>
  track(EventName.AE_NON_FIELD_ACTION_ADD);

const trackAeNonFieldActionDuplicate = (): void =>
  track(EventName.AE_NON_FIELD_ACTION_DUPLICATE);

const trackAeNonFieldActionObjectDials = (): void =>
  track(EventName.AE_NON_FIELD_ACTION_OBJECT_DIALS);

const trackAeNonFieldActionReset = (): void =>
  track(EventName.AE_NON_FIELD_ACTION_RESET);

const trackAeNonFieldActionShowNonActiveVersions = (): void =>
  track(EventName.AE_NON_FIELD_ACTION_SHOW_NON_ACTIVE_VERSIONS);

const trackAeNonFieldActionShowNonRegisteredProducts = (): void =>
  track(EventName.AE_NON_FIELD_ACTION_SHOW_NON_REGISTERED_PRODUCTS);

const trackAePlusBtnNonFieldAction = (): void =>
  track(EventName.AE_PLUS_BTN_NON_FIELD_ACTION);

const trackAeMapLayers = (): void => track(EventName.AE_MAP_LAYERS);

const trackAeMapParcels = (): void => track(EventName.AE_MAP_PARCELS);

const trackAeMapLayersToggle = (p: MapLayersToggleEventProps): void =>
  track(EventName.AE_MAP_LAYERS_TOGGLE, p);

const trackAeMapParcelsAlwaysShow = (p: MapParcelsAlwaysShowEventProps): void =>
  track(EventName.AE_MAP_PARCELS_ALWAYS_SHOW, p);

const trackAeMapParcelsSettingsToggle = (
  p: MapParcelsSettingsToggleEventProps,
): void => track(EventName.AE_MAP_PARCELS_SETTINGS_TOGGLE, p);

const trackAeMapParcelsVisibility = (p: MapParcelsVisibilityEventProps): void =>
  track(EventName.AE_MAP_PARCELS_VISIBILITY, p);

const trackAeMapParcelsLocate = (p: MapParcelsLocateEventProps): void =>
  track(EventName.AE_MAP_PARCELS_LOCATE, p);

const trackAeMapParcelsClose = (): void =>
  track(EventName.AE_MAP_PARCELS_CLOSE);

const trackAeMapParcelsSettings = (): void =>
  track(EventName.AE_MAP_PARCELS_SETTINGS);

const trackAeMapParcelsSettingsBack = (): void =>
  track(EventName.AE_MAP_PARCELS_SETTINGS_BACK);

const trackAeMapParcelsSearchFilters = (): void =>
  track(EventName.AE_MAP_PARCELS_SEARCH_FILTERS);

const trackAeMapParcelsSeasons = (): void =>
  track(EventName.AE_MAP_PARCELS_SEASONS);

const trackAeMapParcelsSearch = (): void =>
  track(EventName.AE_MAP_PARCELS_SEARCH);

const trackAeMapParcelsShowAll = (): void =>
  track(EventName.AE_MAP_PARCELS_SHOW_ALL);

const trackAeMapParcelsHideAll = (): void =>
  track(EventName.AE_MAP_PARCELS_HIDE_ALL);

const trackAeMapParcelsListItem = (): void =>
  track(EventName.AE_MAP_PARCELS_LIST_ITEM);

const trackAeMapParcelsMapClick = (): void =>
  track(EventName.AE_MAP_PARCELS_MAP_CLICK);

const trackAeMapParcelsDetailBack = (): void =>
  track(EventName.AE_MAP_PARCELS_DETAIL_BACK);

const trackDials = (): void => track(EventName.AE_DIALS);

const trackPor = (): void => track(EventName.AE_POR);

const trackPorAdd = (): void => track(EventName.AE_POR_ADD);

const trackPorAdded = (): void => track(EventName.AE_POR_ADDED);

const trackPorCrop = (): void => track(EventName.AE_POR_CROP);

const trackPorCropDetail = (): void => track(EventName.AE_POR_CROP_DETAIL);

const trackPorDetail = (): void => track(EventName.AE_POR_DETAIL);

const trackPorListItem = (): void => track(EventName.AE_POR_LIST_ITEM);

const trackPorRegistration = (): void => track(EventName.AE_POR_REGISTRATION);

const trackHelpIcon = (): void => track(EventName.HELP_ICON);

const trackSupport = (): void => track(EventName.SUPPORT);

const trackTutorials = (): void => track(EventName.TUTORIALS);

const trackTelDashboard = (): void => track(EventName.TEL_DASHBOARD);

const trackTelDashboardMetric = (p: TelDashboardMetricEventProps): void =>
  track(EventName.TEL_DASHBOARD_METRIC, p);

const trackTelDashboardBreakdown = (p: TelDashboardBreakdownEventProps): void =>
  track(EventName.TEL_DASHBOARD_BREAKDOWN, p);

const trackTelDashboardDriverDetail = (): void =>
  track(EventName.TEL_DASHBOARD_DRIVER_DETAIL);

const trackTelDashboardExport = (): void =>
  track(EventName.TEL_DASHBOARD_EXPORT);

const trackTelDashboardDriverLink = (
  p: TelDashboardDriverLinkEventProps,
): void => track(EventName.TEL_DASHBOARD_DRIVER_LINK, p);

const trackPfSection = (): void => track(EventName.PF_SECTION);

const trackIntegrationsSection = (): void =>
  track(EventName.INTEGRATIONS_SECTION);

const trackIntegrationsConnect = (integration: string): void =>
  track(EventName.INTEGRATIONS_CONNECT, { integration });

const trackIntegrationsSettings = (integration: string): void =>
  track(EventName.INTEGRATIONS_SETTINGS, { integration });

const trackIntegrationsSettingsOpen = (integration: string): void =>
  track(EventName.INTEGRATIONS_SETTINGS_OPEN, { integration });

const trackIntegrationsDisconnect = (integration: string): void =>
  track(EventName.INTEGRATIONS_DISCONNECT, { integration });

const trackIntegrationsOrganizationSave = (integration: string): void =>
  track(EventName.INTEGRATIONS_ORGANIZATION_SAVE, { integration });

const trackPfActiveServices = (): void => track(EventName.PF_ACTIVE_SERVICES);

const trackPfParcelNitrogenTab = (): void =>
  track(EventName.PF_PARCEL_NITROGEN_TAB);

const trackPfAddNitrogenApplication = (): void =>
  track(EventName.PF_ADD_NITROGEN_APPLICATION);

const trackPfSaveNitrogenApplication = (): void =>
  track(EventName.PF_SAVE_NITROGEN_APPLICATION);

const trackPfCreateZoningMap = (): void =>
  track(EventName.PF_CREATE_ZONING_MAP);

const trackPfCreateZoningMapFilter = (): void =>
  track(EventName.PF_CREATE_ZONING_MAP_FILTER);

const trackPfCreateZoningMapAddParcel = (): void =>
  track(EventName.PF_CREATE_ZONING_MAP_ADD_PARCEL);

const trackPfFertilizationSelect = (): void =>
  track(EventName.PF_FERTILIZATION_SELECT);

const trackPfAutoDosingTurnOff = (): void =>
  track(EventName.PF_AUTO_DOSING_TURN_OFF);

const trackPfMaterialAndDosingApply = (): void =>
  track(EventName.PF_MATERIAL_AND_DOSING_APPLY);

const trackPfMaterialAndDosing = (): void =>
  track(EventName.PF_MATERIAL_AND_DOSING);

const trackPfParcelDetailAutoDosing = (): void =>
  track(EventName.PF_PARCEL_DETAIL_AUTO_DOSING);

const trackPfParcelDetailApply = (): void =>
  track(EventName.PF_PARCEL_DETAIL_APPLY);

const trackPfCreateZoningMapSave = (): void =>
  track(EventName.PF_CREATE_ZONING_MAP_SAVE);

const trackPfZoningMaps = (): void => track(EventName.PF_ZONING_MAPS);

const trackPfZoningMapsSendData = (): void =>
  track(EventName.PF_ZONING_MAPS_SEND_DATA);

const trackPfZoningMapsSendDataCreateFile = (): void =>
  track(EventName.PF_ZONING_MAPS_SEND_DATA_CREATE_FILE);

const trackPfZoningMapsSendDataJd = (): void =>
  track(EventName.PF_ZONING_MAPS_SEND_DATA_JD);

const trackPfZoningMapsSendDataCnhi = (): void =>
  track(EventName.PF_ZONING_MAPS_SEND_DATA_CNHI);

const trackPfZoningMapsSendDataCreateFileDownload = (): void =>
  track(EventName.PF_ZONING_MAPS_SEND_DATA_CREATE_FILE_DOWNLOAD);

const trackPfZoningMapsSendDataCreateFileSend = (): void =>
  track(EventName.PF_ZONING_MAPS_SEND_DATA_CREATE_FILE_SEND);

const trackPfZoningMapsSendDataCreateFileVehicles = (): void =>
  track(EventName.PF_ZONING_MAPS_SEND_DATA_CREATE_FILE_VEHICLES);

const trackAeSowingCreate = (p: SowingEventProps): void =>
  track(EventName.AE_SOWING_CREATE, p);

const trackAeSowingEdit = (p: SowingEventProps): void =>
  track(EventName.AE_SOWING_EDIT, p);

const trackAeSowingEditFailure = (p: SowingEditFailureEventProps): void =>
  track(EventName.AE_SOWING_EDIT_FAILURE, p);

const trackAeSowingDelete = (p: SowingEventProps): void =>
  track(EventName.AE_SOWING_DELETE, p);

const trackHelpVersionHistory = (): void =>
  track(EventName.HELP_VERSION_HISTORY);

const trackErrorGameStart = (p: ErrorGameStartEventProps): void =>
  track(EventName.ERROR_GAME_START, p);

const trackErrorGameOver = (p: ErrorGameOverEventProps): void =>
  track(EventName.ERROR_GAME_OVER, p);

const trackSensorsHydroLimitsSave = (p: HydroLimitsSaveEventProps): void =>
  track(EventName.SENSORS_HYDRO_LIMITS_SAVE, p);

const trackSensorsHydroLimitsChartToggle = (
  p: HydroLimitsChartToggleEventProps,
): void => track(EventName.SENSORS_HYDRO_LIMITS_CHART_TOGGLE, p);

export {
  EventName,
  trackAeActionFormDeleteAllParcels,
  trackAeFilterApplied,
  trackAeFilterNonFieldAction,
  trackAeFilterNonFieldActionObject,
  trackAeNonFieldActionAdd,
  trackAeNonFieldActionDuplicate,
  trackAeNonFieldActionObjectDials,
  trackAeNonFieldActionReset,
  trackAeNonFieldActionShowNonActiveVersions,
  trackAeNonFieldActionShowNonRegisteredProducts,
  trackAeMapLayers,
  trackAeMapLayersToggle,
  trackAeMapParcels,
  trackAeMapParcelsAlwaysShow,
  trackAeMapParcelsClose,
  trackAeMapParcelsDetailBack,
  trackAeMapParcelsHideAll,
  trackAeMapParcelsListItem,
  trackAeMapParcelsLocate,
  trackAeMapParcelsMapClick,
  trackAeMapParcelsSearch,
  trackAeMapParcelsSearchFilters,
  trackAeMapParcelsSeasons,
  trackAeMapParcelsSettings,
  trackAeMapParcelsSettingsBack,
  trackAeMapParcelsSettingsToggle,
  trackAeMapParcelsShowAll,
  trackAeMapParcelsVisibility,
  trackAePlusBtnNonFieldAction,
  trackAeSowingCreate,
  trackAeSowingDelete,
  trackAeSowingEdit,
  trackAeSowingEditFailure,
  trackDials,
  trackErrorGameOver,
  trackErrorGameStart,
  trackHelpIcon,
  trackHelpVersionHistory,
  trackIntegrationsConnect,
  trackIntegrationsDisconnect,
  trackIntegrationsOrganizationSave,
  trackIntegrationsSection,
  trackIntegrationsSettings,
  trackIntegrationsSettingsOpen,
  trackPfActiveServices,
  trackPfAddNitrogenApplication,
  trackPfAutoDosingTurnOff,
  trackPfCreateZoningMap,
  trackPfCreateZoningMapAddParcel,
  trackPfCreateZoningMapFilter,
  trackPfCreateZoningMapSave,
  trackPfFertilizationSelect,
  trackPfMaterialAndDosing,
  trackPfMaterialAndDosingApply,
  trackPfParcelDetailApply,
  trackPfParcelDetailAutoDosing,
  trackPfParcelNitrogenTab,
  trackPfSaveNitrogenApplication,
  trackPfSection,
  trackPfZoningMaps,
  trackPfZoningMapsSendData,
  trackPfZoningMapsSendDataCnhi,
  trackPfZoningMapsSendDataCreateFile,
  trackPfZoningMapsSendDataCreateFileDownload,
  trackPfZoningMapsSendDataCreateFileSend,
  trackPfZoningMapsSendDataCreateFileVehicles,
  trackPfZoningMapsSendDataJd,
  trackPor,
  trackPorAdd,
  trackPorAdded,
  trackPorCrop,
  trackPorCropDetail,
  trackPorDetail,
  trackPorListItem,
  trackPorRegistration,
  trackSensorsHydroLimitsChartToggle,
  trackSensorsHydroLimitsSave,
  trackSupport,
  trackTelDashboard,
  trackTelDashboardBreakdown,
  trackTelDashboardDriverDetail,
  trackTelDashboardDriverLink,
  trackTelDashboardExport,
  trackTelDashboardMetric,
  trackTutorials,
  type ActivityFilterScreen,
  type HydroLimitsChartToggleSource,
};
